// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-2bpkC";
var _3 = "button_small-3Meeq";
export { _1 as "__esModule", _2 as "button", _3 as "button_small" }
export default { "__esModule": _1, "button": _2, "button_small": _3 }
